import { createContext, ReactNode, useContext } from 'react';
import {
    defaultAccountSectors,
    defaultContactGender,
    defaultQuoteCategories,
    defaultQuotePipelineStatuses,
    defaultQuoteStages,
    defaultLogo,
    defaultNoteStatuses,
    defaultTaskTypes,
    defaultTitle,
} from './defaultConfiguration';
import { ContactGender, QuoteStage, NoteStatus } from '../types';

// Define types for the context value
export interface ConfigurationContextValue {
    accountSectors: string[];
    quoteCategories: string[];
    quotePipelineStatuses: string[];
    quoteStages: QuoteStage[];
    noteStatuses: NoteStatus[];
    taskTypes: string[];
    title: string;
    logo: string;
    contactGender: ContactGender[];
}

export interface ConfigurationProviderProps extends ConfigurationContextValue {
    children: ReactNode;
}

// Create context with default value
export const ConfigurationContext = createContext<ConfigurationContextValue>({
    accountSectors: defaultAccountSectors,
    quoteCategories: defaultQuoteCategories,
    quotePipelineStatuses: defaultQuotePipelineStatuses,
    quoteStages: defaultQuoteStages,
    noteStatuses: defaultNoteStatuses,
    taskTypes: defaultTaskTypes,
    title: defaultTitle,
    logo: defaultLogo,
    contactGender: defaultContactGender,
});

export const ConfigurationProvider = ({
    children,
    accountSectors,
    quoteCategories,
    quotePipelineStatuses,
    quoteStages,
    logo,
    noteStatuses,
    taskTypes,
    title,
    contactGender,
}: ConfigurationProviderProps) => (
    <ConfigurationContext.Provider
        value={{
            accountSectors,
            quoteCategories,
            quotePipelineStatuses,
            quoteStages,
            logo,
            noteStatuses,
            title,
            taskTypes,
            contactGender,
        }}
    >
        {children}
    </ConfigurationContext.Provider>
);

export const useConfigurationContext = () => useContext(ConfigurationContext);
